import { isCROReservationPathname } from 'frontend-container/components/Menu/utils/modules/centralReservationOffice';

export const isPropertySelectorReadOnlyVisible = (): boolean => {
  return [isCROReservationPathname()].some(Boolean);
};
